// src/ecrans/AvecAncienEcran.jsx — le nouvel écran, ou l'ancien tant que le
// geste n'a pas sa porte d'écriture : « Aucun geste retiré à l'admin » (P-4.24).
// `nouvel(ouvrirAncien)`, `ancien(cle)` : deux rendus, un seul à la fois.

import { useState } from "react";

export default function AvecAncienEcran({ nouvel, ancien }) {
  const [cle, setCle] = useState(null);
  if (cle === null) return nouvel((c) => setCle(c || "ancien"));
  return (
    <>
      <button
        type="button"
        data-testid="retour-nouvel-ecran"
        onClick={() => setCle(null)}
        style={{ border: "1px solid #D6DDDA", background: "#fff", borderRadius: 10, padding: "0 13px", minHeight: 44, fontSize: 12, fontWeight: 600, cursor: "pointer", margin: "10px 0" }}
      >
        ‹ Revenir au nouvel écran
      </button>
      {ancien(cle)}
    </>
  );
}
